import { Button, Modal } from "../../../components";
import { useCustomTranslation } from "../../../helpers/translateHelpers";

interface RequestResolveConfirmModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const RequestResolveConfirmModal = ({
  onClose,
  onConfirm,
  open,
}: RequestResolveConfirmModalProps) => {
  const { t, tRequest } = useCustomTranslation();

  return (
    <Modal
      isOpen={open}
      onClose={onClose}
      title={tRequest("resolve_confirm_title")}
      className="w-[450px]"
    >
      <p>{tRequest("resolve_confirm_description")}</p>
      <div className="mt-4 flex flex-row items-center justify-between">
        <Button label={t("cancel")} onClick={onClose} />
        <Button
          label={tRequest("resolve")}
          type="button"
          onClick={() => onConfirm()}
          className="bg-success text-white hover:bg-gradient-to-t hover:from-[rgba(0,0,0,0.20)] hover:to-[rgba(0,0,0,0.20)]"
        />
      </div>
    </Modal>
  );
};

export default RequestResolveConfirmModal;
